import styled from 'styled-components';
import {
  Input,
} from 'antd';
import {
  COLOR_CV_5,
} from 'constants/colors';

export const StyledAntdInputSearch = styled(Input.Search)`
  & .ant-input,
  & .ant-btn {
    &:hover,
    &:active,
    &:focus {
      border-color: ${COLOR_CV_5};

      & + .ant-input-group-addon .ant-input-search-button:not(.ant-btn-primary) {
        border-left-color: ${COLOR_CV_5};
      }
    }

    &:focus {
      box-shadow: 0 0 0 2px ${COLOR_CV_5}14;
    }

    &-affix-wrapper{
      &:not(.ant-input-affix-wrapper-disabled) {
        &:hover,
        &:active,
        &:focus {
          border-color: ${COLOR_CV_5};
        }
  
        &:focus {
          box-shadow: 0 0 0 2px ${COLOR_CV_5}14;
        }
      }
      &-focused {
        border-color: ${COLOR_CV_5};
        box-shadow: 0 0 0 2px ${COLOR_CV_5}14;
      }
    }
  }
`;
